<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>
    
    <div v-if="this.loadingFormSubmit == false" class="form-container">
      <el-card class="form-card">
        <el-form :model="form" :rules="rules" ref="form" label-position="top">
          <el-form-item label="Work Order Title" prop="issuetitle">
            <el-input
              class="tst-issue-title"
              v-model="form.issuetitle"
              :rules="inputRules"
              placeholder="ex: machine makes a loud noise"
              style="min-width: 250px;"
              required
            ></el-input>
          </el-form-item>

          <el-form-item label="Work Order Description">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              class="tst-issue-desc"
              v-model="form.description"
              :rules="inputRules"
              placeholder="ex: machine makes a loud noise when turning on, please check on it."
              style="min-width: 250px;"
              required
            ></el-input>
          </el-form-item>

       <!-- this section is if the issue is not inside a machine -->
          <div v-if="!this.$route.params.MachineId">

              <el-form-item label="Choose property for the work order" >

                  <el-dropdown @command="selectProperty" trigger="click">
                      <el-button type="primary">
                                {{selectedProperty.propertyname}}<i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>

                    <el-dropdown-menu style="position: relative; overflow-x: scroll; max-height: 450px; max-width: 302px;" slot="dropdown">
                      <el-dropdown-item v-for="property in this.propertiesLinkedToUser" :command="property" :key="property.propertyid" >
                          {{property.propertyname}}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

              </el-form-item>

              <el-form-item label="Choose asset for the work order. Optional">

                  <el-dropdown trigger="click" :hide-on-click="false" >
                      <el-button type="primary">
                               {{selectedMachineName}} <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>

                    <el-dropdown-menu  
                     style="position: relative; overflow-x: scroll; max-height: 450px; max-width: 302px; pointer-events: none;" slot="dropdown">
                      <el-dropdown-item 
                      v-for="machine in this.machinesOfSelectedProperty" 
                      :key="machine.machineid"
                      >
                        <input type="checkbox" style=" pointer-events: auto;" id="checkbox" @click="addRemoveAssetForIssue(machine.machineid)" >
                        <label for="checkbox">  {{machine.machinename}}</label>  
                      </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
               
                <!-- first index is null if the issue is being created not inside machine page, see in data() -->
                 <p class="assets-selected"
                    v-if="this.form.machineid.length > 0 &&
                          this.form.machineid[0] != null"> 
                              You selected {{firstMachineName()}} 
                    <span v-if="this.form.machineid.length > 1"> and {{this.form.machineid.length - 1}} more </span>
                 </p>
             </el-form-item>
          </div>

          <el-form-item label="assign a tech to the Work Order">
         <!-- assign to issue especially takes the propertyid from the form because This is being 
         changed when selecting property and the assign to issue component is watching the change -->
            <AssignToIssue
              v-on:contact-assigned="assignContact($event)"
              :propertyid="this.form.propertyid"
              :machineid="this.machineid"
            />
          </el-form-item>

          <el-form-item label="Select priority level">
            <el-dropdown @command="selectPriority" trigger="click">
                  <el-button type="primary">
                    {{selectedPriority.issuepriorityname}}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>

              <el-dropdown-menu  slot="dropdown">
                <el-dropdown-item
                    v-for="priority in this.priorityList"
                    :key="priority.issuepriorityid"
                    :command="priority"
                >
                  {{priority.issuepriorityname}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>

          <el-form-item>    
              <input type="checkbox" id="checkbox" v-model="form.recurring">
               <label for="checkbox"> Recurring work order?</label>      
          </el-form-item>

          <el-form-item label="due date" v-if="form.recurring == false">
            <el-date-picker class="tst-issue-duedate"
              v-model="form.duedate" type="date" placeholder="Pick a day"></el-date-picker>

            <p class="error"
            v-if="this.duedateError == true"
            > Can't be earlier than today </p>

          </el-form-item>

             <!-- <el-form-item label="due date" v-if="form.recurring == false">
            <el-date-picker class="tst-issue-duedate"
              v-model="form.duedate" type="date" placeholder="Pick a day"></el-date-picker>
             </el-form-item> -->
         
          <!-- <el-form-item >
               <input type="checkbox" id="trackable-checkbox" v-model="form.istimetrackable">
               <label for="trackable-checkbox"> Can track hours?</label>      
          </el-form-item> -->

<div v-if="form.recurring == true">

         <!-- <el-form-item label="Task cycle">
          <template>
           <el-radio v-model="form.scheduletype" label="Weekly">Weekly</el-radio>
           <el-radio v-model="form.scheduletype" label="interval">Interval</el-radio>
          </template>
          </el-form-item> -->

       
     <!-- <el-dropdown
      v-if="this.form.scheduletype == 'Weekly'" 
      @command="setDay" trigger="click"
        style="margin: 25px 0px"
      >
        <el-button type="primary">
        {{selectedDay}}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu   slot="dropdown">
            <el-dropdown-item v-for="day in this.weekdays" :command="day" :key="day">
              {{day}}
            </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
 <el-form-item 
          v-if="this.form.scheduletype == 'interval'" 
         label="Recurring days"
         prop="recurringDaysIntervalNumber"
 >
       <el-input          
       v-model="form.recurringDaysIntervalNumber" 
       placeholder="Enter number of days"
       oninput="this.value = this.value.replace(/[^0-9]/g, '')"
       > </el-input>

 </el-form-item>
          <el-form-item        
           label="Start date"
           >

             <el-date-picker v-model="form.startdate" type="date" placeholder="Pick a day"></el-date-picker>
               <p class="error"
         v-if="this.startdateError == true"
         > Can't be earlier than today </p>
          <p class="error"
         v-if="this.propertyZoneError == true"
         > Date earlier than property timezone </p>
          </el-form-item>

          <el-form-item label="How long before can be completed">
              <el-input 
                v-model="form.cancompletedaysbefore" 
                placeholder="Enter number of days"
                oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                > </el-input>
          </el-form-item>
         <p class="error"
         v-if="this.canCompleteError"
         > must be lower than recurring days </p>

</div>


          <el-button class="tst-confirm-create-issue-button"
              @click="SubmitIssue()">Submit</el-button>

          <el-button class="tst-cancel-button" @click="closeCreateIssueForm()">Cancel</el-button>
        </el-form>
      </el-card>
    </div>

    <!-- this is just to add space to the component, because if not the bottom menu is overlapping content -->
    <div style="min-height: 70px;"> </div>
  </div>
</template>
 
<script>
import EventService from "@/services/EventService.js";
import { mapState } from "vuex";
import AssignToIssue from "@/components/issues/AssignToIssue.vue";
import moment from 'moment';

export default {
  props: {
    propertyid: String,
    machineid: String,
    priorityList: Array
      },
  components: {
    AssignToIssue
  },
  data() {
    return {
      dialog: false,
      propertiesLinkedToUser: [],
      machinesOfSelectedProperty: [],
      currentPropertyTimeOffset: "",
      selectedProperty: {},
      selectedMachineName: "Choose Asset",
      selectedPriority: {},
      form: {
        issuetitle: null,
        userassigned: null,       
         //if the user creates issue not within property then this machine id in the first index is null and is handled 
         // in addRemoveAssetForIssue() if he chooses assets in the dropdown, and handled at SubmitIssue() if he didn't choose any asset
        machineid: [this.machineid],
        //if the user creates issue not within property - meaning that he has to choose property - then the
        // property id gets set in created(), and then changed if the user changes
        propertyid: this.propertyid,
        userid: "",
        description: "",
        duedate: null,
        scheduletype: "interval",
        cancompletedaysbefore: null,
        startdate: null,
        recurringdays: [],
        recurring: false,
        istimetrackable: false,
        issuepriorityid: "",
        //this is not a value necessary for submit, it's in the form object for validation purposes
        recurringDaysIntervalNumber: 14,
      },
      propertyZoneError: false,
      canCompleteError: null,
      duedateError: false,
      startdateError: false,
      inputRules: [v => (v && v.length != 0) || "This field is required"],
      rules: {
          issuetitle: [
            { required: true, message: 'Please input Issue Title', trigger: 'blur' },
          ],
            recurringDaysIntervalNumber: [
            {  required: true, trigger: 'blur', message: 'Please input number of recurring days' },
          ]
       },
      invalid: Boolean,
      loadingFormSubmit: false
    };
  },

  mounted() {
   
    this.form.userid = this.user.userid;
    
    // prop machineid comes  in undefined if the form is on a issues page that is not inside a machine
    if(this.machineid != undefined){
        EventService.getSingleMachineInfo(this.machineid).then(
          response => (this.form.propertyid = response.data.propertyid)
        );
    } else {
      EventService.getAllPropertiesBasicInfo(this.user.userid).then( response => {
          this.propertiesLinkedToUser = response.data;
          this.selectProperty(this.propertiesLinkedToUser[0]);
     });
    }
    
    // in case the prop priorityList isn't defined already,
    // the watch:{} will catch when it gets defined and do the work
    if(this.priorityList != undefined && this.priorityList.length > 0)
    {
      var lowPriorityObject = this.priorityList.find(i => i.issuepriorityname === 'Low');

      this.selectPriority(lowPriorityObject);
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },
  watch: {

    // when priority gets defined in the prop, then select one as default
    priorityList:{
       handler(newVal){
          if(newVal != undefined)
          {
             var lowPriorityObject = this.priorityList.find(i => i.issuepriorityname === 'Low');

             this.selectPriority(lowPriorityObject);
          }
       }
    }
  },
  methods: {
    assignContact($event) {
      if($event == "Unassigned"){
         this.form.userassigned = null;
      }
      this.form.userassigned = $event;
    },
    closeCreateIssueForm() {
      this.$emit("close-create-issue-form");
    },
    selectProperty(property){
      this.selectedProperty = property;
      this.form.propertyid = property.propertyid;
      this.currentPropertyTimeOffset = property.propertytimeoffset;
      this.getMachinesOfProperty(this.form.propertyid);
      this.form.machineid = [null];
      this.selectedMachineName = "Choose Asset";
      
      this.form.userassigned = null;

      var proertyIdsForApi = {
       propertyid: [property.propertyid]
      }

    },

    getMachinesOfProperty(propertyid){
       EventService.GetPropertiesMachinesBasicInfo(propertyid).then( response => {
         this.machinesOfSelectedProperty = response.data;
       })
    },
    selectPriority(priority){
       this.selectedPriority = priority;
       this.form.issuepriorityid = priority.issuepriorityid;
    },
    // selectMachine(machine){
    //   this.selectedMachineName = machine.machinename;
    //   this.form.machineid = machine.machineid;
    // },
    addRemoveAssetForIssue(machineid){

        if(this.form.machineid[0] == null){
          this.form.machineid.shift();
        }

        var indexInArray = this.form.machineid.indexOf(machineid);

        if (indexInArray > -1) {
          this.form.machineid.splice(indexInArray, 1);
        }
        else{
            this.form.machineid.push(machineid);
        }
    },
    firstMachineName(){

       var firstMachineObject = this.machinesOfSelectedProperty.filter(i => i.machineid == this.form.machineid[0])[0];
       
       return firstMachineObject.machinename;
    },
    SubmitIssue() {

       this.$refs["form"].validate((valid) => {
          if (valid) {
          } else {
            this.invalid = true;
            return false;
          }
        });

        if(this.invalid == true){
         this.invalid = false;
          return;
        }

        if(this.form.recurring == true){

            if(this.form.cancompletedaysbefore != null){
              this.form.cancompletedaysbefore = Number(this.form.cancompletedaysbefore);
            }
            this.recurringDaysIntervalNumber = Number(this.recurringDaysIntervalNumber);

          if(this.form.recurringDaysIntervalNumber <= this.form.cancompletedaysbefore){
              this.canCompleteError = true;
              return;
            }

            if(this.form.startdate != null && this.form.startdate < new Date().setHours(0,0,0,0) ){
              this.startdateError = true;
              return;
            }

            
            var dateTimeInPropertyTimezone = this.getPropertyNowDate();

            var dateInProperty = new Date(dateTimeInPropertyTimezone);
          
            if(this.form.startdate != null && 
              dateInProperty.setHours(0,0,0,0) > this.form.startdate.setHours(0,0,0,0) )
            {
              this.propertyZoneError = true;
              return;
            }


            this.form.recurringdays.push(this.form.recurringDaysIntervalNumber);
          
              this.form.duedate = null;
        }

       if(this.form.duedate != null && this.form.duedate < new Date().setHours(0,0,0,0)){
          this.duedateError = true;
           return;
        }

     // machine id first index is null if the create issue form wasn't called from the machine page
     // and it's undefined if he picked machines in the form and then unchecked all 
     if(this.form.machineid[0] == null || this.form.machineid[0] == undefined)
     {
        this.form.machineid = null;
     }

     if(this.form.startdate != null)
     {
        // this is very important, because this keeps the date according to the time zone of the users computer, and not the UTC time.
        // if this is not done, the database can end up with a different date then the user entered, for example it's 11 at night fabruary
        // 1 at the users location, but in utc it's already 2 AM from fabruary 2, then the system would post fabruary 2 (with UTC offset), and
        // we in the back end take the date from the user straight and enter it in the database, without playing with the time zone since we
        // want the date to be exactly as the user had set it no matter the property time zone, then it would be inaccurate. As said this
        // line will avoid it. for more details on time zones in work orders, see docmentation section "Time zone for work orders"
        this.form.startdate = moment(this.form.startdate).format();
     }

     if(this.form.duedate != null)
     {
       // this is doing the same as the earlier code block, for the due date instead of the start date. see comment above.
        this.form.duedate = moment(this.form.duedate).format();
     }

     this.loadingFormSubmit = true;
      EventService.addIssue(this.form).then(response => {

        this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Work Order Added"
          })
          
          var issueListReturned = response.data.issuelistreturn;

          // if the issue is in "users issues" page add inside the issue object the can assign permission of the property
          // it belongs to, and also the property offset
          if(this.$route.fullPath.includes("UsersIssues")){
              issueListReturned.forEach(issue => {
                  var issueIndexInArray = issueListReturned.indexOf(issue);

               //   issueListReturned[issueIndexInArray].propertytimeoffset = this.currentPropertyTimeOffset;
        
              });
           }
     
        this.$emit("list-of-new-issues", issueListReturned);
        this.closeCreateIssueForm();
      })        
      .catch(error => {
          console.log(error);
          this.closeCreateIssueForm();
      });

      this.clearForm();
    },
    getPropertyNowDate(){
       var now = new Date();

   // this is really a date of the users timezone since the offset at the end of the date doesn't say
   // 00:00 as utc but it says the current offset, but the idea is to just to add the hours to the local 
   // date it should match the hours of the current utc time. it's kind of a hack due to weak support for
   // (utc) dates in JavaScript

       var fakeUtcDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);

       fakeUtcDate.setHours(fakeUtcDate.getHours() + Number(this.timezoneDifference().timezoneHourDifference));

       var propertyZoneNowDate = fakeUtcDate.setMinutes(fakeUtcDate.getMinutes() + Number(this.timezoneDifference().timezoneMinuteDifference));
         
       return propertyZoneNowDate;
    },
     timezoneDifference(){
        var timezoneHourDifference = 0;

        var timezoneMinuteDifference = 0;

        

          if(this.currentPropertyTimeOffset.charAt(1) > 0 || this.currentPropertyTimeOffset.charAt(2) > 0){

                      if(this.currentPropertyTimeOffset.startsWith("-")){
                       timezoneHourDifference = this.currentPropertyTimeOffset.substring(0, 3);
                       timezoneMinuteDifference =  "-" + this.currentPropertyTimeOffset.substring(4, 6);

                      } else {
                      timezoneHourDifference = this.currentPropertyTimeOffset.substring(0, 2);
                      timezoneMinuteDifference = this.currentPropertyTimeOffset.substring(3, 5)

                      }
              } else{
                            if(this.currentPropertyTimeOffset.startsWith("-")){
                             timezoneMinuteDifference =  "-" + this.currentPropertyTimeOffset.substring(4, 6);
                            } else {
                              timezoneMinuteDifference = this.currentPropertyTimeOffset.substring(3, 5);
                            }
              } 

              return {
                timezoneHourDifference: timezoneHourDifference,
                timezoneMinuteDifference: timezoneMinuteDifference
              }
    },
    clearForm() {
      this.form = {
        issuetitle: "",
        userassigned: null,
        machineid: [this.machineid],
        propertyid: this.propertyid,
        userid: "",
        description: "",
        issueid: ""
      };
    }
  }
};
</script>

<style scoped>
.error{
  color: red;
    font-size: 12px;
    margin: -12px 15px 15px 0px;
}
.assets-selected{
    margin: 0;
    font-style: italic;
}
</style>
